<template>
  <v-container
    id="report-employees"
    fluid
    tag="section"
  >
    <filter-form :filterForm="filterForm"/>
    <report-employees-table :filterForm="filterForm" :convertEmployees="convertEmployees" />
    <common-no-result
      v-if="!loading && totalItem === 0"
    />
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import FilterForm from "./components/FilterForm";
  import { formatDate } from '../../../helpers/utils'
  import ReportEmployeesTable from "./components/ReportEmployeesTable";
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import * as moment from 'moment'

  const CallCenterRespository = RepositoryFactory.get('call_center')
  export default {
    components: { FilterForm, ReportEmployeesTable },
    data () {
      return {
        filterForm: {
          dateRange: {
            startDate: moment().startOf('days').format('YYYY-MM-DD 00:00:00'),
            endDate: moment().endOf('days').format('YYYY-MM-DD 23:59:59'),
          },
          ministryId: '',
          shift: []
        },
        convertEmployees: [],
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        loading: false,
      }
    },
    created () {
      this.getEmployeesList()
      Bus.$on('report-employees-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.getEmployeesList()
      })
    },
    beforeDestroy() {
      Bus.$off('report-employees-list-filter');
    },
    watch: {
      currentPage: {
        handler() {
          this.getEmployeesList()
        }
      },
      limit: {
        handler() {
          if (this.currentPage === 1) {
            this.getEmployeesList()
          } else {
            this.currentPage = 1
          }
        }
      }
    },
    methods: {
      async getEmployeesList () {
        this.loading = true

        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          shift: this.filterForm.shift,
          ministryId: this.filterForm.ministryId,
          startDate: formatDate(this.filterForm.dateRange.startDate),
          endDate: formatDate(this.filterForm.dateRange.endDate),
        }
        // const loader = this.$loading.show()
        this.appLoadingData(true)
        const response = await CallCenterRespository.reportEmployeesList(params)
        // loader.hide()
        this.appLoadingData(false)
        this.loading = false
        if (response.success) {
          this.convertEmployees =_.get(response, 'data', [])
          this.totalItem = _.get(response, 'totalItem', 0)
        }
      },
    }
  }
</script>
